// extracted by mini-css-extract-plugin
export default {"root":"w1+Jl5YW","weekday":"ehsPWoHC","day":"Yh5oqfR-"};